import React, { useRef, useEffect, useState, useMemo } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { usePerformance } from '../hooks/usePerformance';

const ParallaxSection = ({ children, speed = 0.5, className = '' }) => {
  const { isLowPerformance, isReducedMotion } = usePerformance();
  const ref = useRef();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });

  // Reducir velocidad de parallax en dispositivos lentos
  const parallaxSpeed = useMemo(() => {
    if (isReducedMotion) return 0;
    if (isLowPerformance) return speed * 0.3;
    return speed;
  }, [speed, isLowPerformance, isReducedMotion]);

  const y = useTransform(scrollYProgress, [0, 1], [0, -100 * parallaxSpeed]);

  // Si el movimiento está reducido, no aplicar parallax
  if (isReducedMotion) {
    return (
      <div ref={ref} className={className}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      style={{ y }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default ParallaxSection; 